<template>
  <div class="page-header" ref="hero">
    <div class="page-header__breadcrumb">
      <div class="page-header__breadcrumb__item__wrapper">
        <router-link class="page-header__breadcrumb__item btn" exact to="/"><span class="btn__inner">Home</span></router-link>
      </div>
      <div class="page-header__breadcrumb__item__wrapper" v-if="this.$router.currentRoute.name === 'post'">
        <router-link class="page-header__breadcrumb__item btn" exact to="/writing"><span class="btn__inner">Writing</span></router-link>
      </div>
      <div class="page-header__breadcrumb__item__wrapper">
        <p class="page-header__breadcrumb__item">{{ currentRouteTitle }}</p>
      </div>
    </div>
    <div class="page-header__title">
      <h1 class="mb-0" tabindex="0">{{ currentRouteTitle }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  data: function () {
    return {
      currentRoutePath: '',
      currentRouteTitle: ''
    }
  },
  props: {
    postTitle: {
      type: String,
      default: ''
    }
  },
  created () {
    this.currentRoutePath = this.$router.currentRoute.fullPath

    if (this.postTitle === '') {
      this.currentRouteTitle = this.$router.currentRoute.name[0].toUpperCase() + this.$router.currentRoute.name.slice(1)
    } else {
      this.currentRouteTitle = this.postTitle
    }
  },
  watch: {
    postTitle (postTitle) {
      if (this.postTitle === '') {
        this.currentRouteTitle = this.$router.currentRoute.name[0].toUpperCase() + this.$router.currentRoute.name.slice(1)
      } else {
        this.currentRouteTitle = this.postTitle
      }
    }
  }
}
</script>

<style lang="scss">
// ==============================
// Page header
// ========================================

.page-header {
  width: 100%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  text-align: left;

  @include mq($from: tablet) {
    margin-top: 60px;
  }
}

// ==============================
// Page header breadcrumb
// ========================================

.page-header__breadcrumb {

}

// ==============================
// Page header breadcrumb item
// ========================================

.page-header__breadcrumb__item {
  display: inline;
  line-height: 2.25;

  @include mq($until: mobileLandscape) {
    font-size: 1.25rem;
  }

  &__wrapper {
    display: inline;

    &:not(:last-child) {
      position: relative;
      margin-right: 22px;

      &:after {
        content: '/';
        position: absolute;
        top: 50%;
        right: -14px;
        transform: translateY(-50%);
      }
    }
  }
}

// ==============================
// Page header title
// ========================================

.page-header__title {
  margin-top: 16px;

  h1 {
    display: inline;
    color: $color-b-primary;
    background: -webkit-linear-gradient($color-a-primary, $color-b-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

</style>
